<template>
  <div class="whyPartnery-body">
    <div class="title-box">Why Partner with Wecobi?</div>
    <div class="text-box-wrapper">
      <TextBoxGroup :textBoxes="firstGroup" />
      <TextBoxGroup :textBoxes="secondGroup" />
    </div>
  </div>
</template>

<script>
import TextBoxGroup from "../SharedComponents/TextBoxGroup.vue";

export default {
  name: "WhyPartner",
  components: {
    TextBoxGroup,
  },
  data() {
    return {
      firstGroup: [
        {
          title: "Make a Difference",
          text: "Be part of a global movement toward sustainability. Help promote conscious consumerism by supporting brands that reduce waste and give unsold products a second life.",
        },
        {
          title: "Earn Commission",
          text: "As an influencer partner, you can monetize your platform by sharing Wecobi campaigns with your audience. Earn commissions on every successful referral and sale through your unique link.",
        },
      ],
      secondGroup: [
        {
          title: "Access Exclusive Content",
          text: "Gain early access to brand campaigns and collaborate on exciting, eco-friendly product launches that resonate with your audience’s values.",
        },
        {
          title: "Build Your Influence",
          text: "Align your personal brand with sustainability and innovation. By partnering with Wecobi, you’ll tap into a growing community of conscious consumers and brands looking to make a positive impact.",
        },
      ],
    };
  },
};
</script>

<style scoped>
.whyPartnery-body {
  width: 100%;
  height: fit-content;
  padding: 70px 60px;
  box-sizing: border-box;
}

.title-box {
  width: 100%;
  font-size: 27px;
  font-weight: 400;
  line-height: 1.2;
  color: #ff6d0a;
  border-bottom: 2px solid #ff6d0a;
  padding-bottom: 7px;
}

.text-box-wrapper {
  padding-top: 50px;
  display: flex;
  flex-direction: column;
  gap: 50px;
}

@media (max-width: 744px) {
  .whyPartnery-body {
    padding: 60px 40px;
  }
}

@media (max-width: 588px) {
  .whyPartnery-body {
    padding: 60px 30px;
  }
}

@media (max-width: 431px) {
  .text-box-wrapper {
    padding-top: 30px;
    gap: 30px;
  }
}
</style>
